module.exports = __webpack_public_path__ + "static/img/14.8d215db3.png";